import { Tab, Tabs } from "@wfp/ui"
import { Outlet, useLocation, useNavigate } from "react-router-dom"

const tabs = [
  { label: "Asset Category", path: "asset-category" },
  { label: "Asset Subcategory", path: "asset-subcategory" },
  { label: "Asset Details", path: "asset-details" },
  { label: "Outcomes", path: "outcomes" },
  { label: "Contract Types", path: "contract-types" },
]

export default function SettingsPage() {
  const navigate = useNavigate()
  const location = useLocation()

  const currentPath = location.pathname.split("/").pop() || ""
  const selectedIndex = Math.max(
    tabs.findIndex(tab => tab.path === currentPath),
    0,
  )

  return (
    <>
      <h2 className="m-0 mb-3 mt-2">Settings</h2>
      <Tabs
        customTabContent
        selected={selectedIndex}
        onSelectionChange={
          ((index: number) => {
            navigate(tabs[index].path)
          }) as any
        }
      >
        {tabs.map((tab, index) => (
          <Tab
            key={tab.path}
            label={tab.label}
            href=""
            role="tab"
            selected={selectedIndex === index}
            tabIndex={index}
          />
        ))}
      </Tabs>
      <div className="mt-3">
        <Outlet />
      </div>
    </>
  )
}
